import { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Filemanager from "./components/Files/Filemanager";

const Files = () => {
  const [isPayedUser] = useState(true);

  const { t } = useTranslation();

  return isPayedUser ? (
    <Filemanager useGrid={true} showDelete={true}/>
  ) : (
    <Row>
      <Col>
        <Card>
          <Card.Body>
            <Row>
              <Col>
                <h5>This is a premium feature</h5>
                <p>
                  However: If you contact and follow me on
                  <a href="https://www.linkedin.com/in/felixdziekan/">
                    LinkedIn
                  </a>
                  or on{" "}
                  <a href="https://www.facebook.com/felix.dziekan">Facebook</a>
                  I'll give you full access for one year for free.
                </p>
                <iframe
                  src="https://www.youtube-nocookie.com/embed/Vp5i9M8T7DQ?si=m4u0J9sA8cD1EFzf&vq=hd1080"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </Col>
            </Row>
            <Row>
              <Col></Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Files;
